import React from 'react';
import { Shield, Truck, Award, HeadphonesIcon, BadgeCheck, Percent } from 'lucide-react';

const features = [
  {
    icon: BadgeCheck,
    title: 'Licensed Pharmacy',
    desc: 'Fully licensed and verified',
    color: 'text-teal-600 bg-teal-50',
  },
  {
    icon: Shield,
    title: 'Genuine Products',
    desc: '100% authentic medicines',
    color: 'text-blue-600 bg-blue-50',
  },
  {
    icon: Truck,
    title: 'Fast Delivery',
    desc: 'Express shipping available',
    color: 'text-emerald-600 bg-emerald-50',
  },
  {
    icon: Percent,
    title: 'Best Prices',
    desc: 'Guaranteed lowest prices',
    color: 'text-orange-600 bg-orange-50',
  },
  {
    icon: Award,
    title: 'Quality Assured',
    desc: 'FDA approved products',
    color: 'text-purple-600 bg-purple-50',
  },
  {
    icon: HeadphonesIcon,
    title: '24/7 Support',
    desc: 'Expert help anytime',
    color: 'text-rose-600 bg-rose-50',
  },
];

const WhyChooseUs = () => {
  return (
    <section className="py-8 bg-white dark:bg-gray-900" data-testid="why-choose-us">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {features.map((f, i) => {
            const Icon = f.icon;
            return (
              <div
                key={i}
                className="flex flex-col items-center text-center p-4 rounded-xl hover:shadow-md transition-all group cursor-default"
              >
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-2.5 ${f.color} group-hover:scale-110 transition-transform`}>
                  <Icon className="w-6 h-6" />
                </div>
                <h4 className="text-sm font-semibold text-gray-800 dark:text-white">{f.title}</h4>
                <p className="text-xs text-gray-500 mt-0.5">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
